<!--优惠券展示组件-->
<template>
  <div class="Coupons app-container">
    <div class="coupon-container">
      <div v-if="couponList.length">
        <div class="coupon-item" v-for="item in couponList" :key="item.id" :class="{ grayscale: item.expired === 1 }">
          <div class="left-container">
            <div style="display: flex;justify-content: right">
              <div class="number">{{ item.amountB }}</div>
              <div class="symbol">{{ $symbol() }}</div>
            </div>
          </div>
          <div class="right-container">
            <div class="title">Cash Coupon</div>
            <div class="date">{{ getDateString(item.useStartDate) }}-{{ getDateString(getLastSecond(item.useEndDate)) }}
            </div>
          </div>
          <div class="couponNo">
            {{ item.couponNo }}
          </div>
          <div v-if="item.status === 1" class="useData">
            <!--已使用-->
            {{ $t('Used') }}:{{ item.useOrderNo }}
          </div>
        </div>
      </div>
      <div v-else>
        <!--暂无优惠券-->
        <div class="no-coupon">{{ $t('No_Coupon') }}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Coupons',
  props: {
    msg: String,
    couponList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  directives: {},
  components: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  activated() {
  },
  methods: {
    getLastSecond(dateString) {
      const date = new Date(dateString)
      const timestamp = date.getTime()
      const date2 = new Date(timestamp - 1000)
      const year = date2.getFullYear();
      const month = String(date2.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要加1，并且用padStart确保是两位数
      const day = String(date2.getDate()).padStart(2, '0'); // 用padStart确保是两位数
      const hours = String(date2.getHours()).padStart(2, '0'); // 用padStart确保是两位数
      const minutes = String(date2.getMinutes()).padStart(2, '0'); // 用padStart确保是两位数
      const seconds = String(date2.getSeconds()).padStart(2, '0'); // 用padStart确保是两位数
      const formattedDate = `${year}-${month}-${day}`;
      const formattedTime = `${hours}:${minutes}:${seconds}`;
      return `${formattedDate} ${formattedTime}`
    },
    getDateString(dateString) {
      const date = new Date(dateString)
      const timestamp = date.getTime()
      const date2 = new Date(timestamp);
      const localDateTimeString = date2.toLocaleString();
      return localDateTimeString.slice(0, 9)
    },
  }
}

</script>

<style lang="scss" scoped>
.coupon-container {
  width: 100%;

  .coupon-item {
    width: calc(100% - 8px);
    height: 180px;
    border-radius: 20px;
    border: 4px solid #ccc;
    margin-bottom: 5px;
    background-image: url("~@/assets/images/coupon-bg.jpg");
    background-size: cover;
    background-position: right;
    background-repeat: no-repeat;
    position: relative;
    display: flex;
    color: white;

    .couponNo {
      color: #333;
      position: absolute;
      top: 10px;
      left: 10px;
    }

    .left-container {
      flex: 4;
      height: 100%;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .number {
        line-height: 180px;
        font-size: 40px;
        font-weight: 600;
      }

      .symbol {
        margin: 0 10px 0 0;
        line-height: 190px;
        font-size: 30px;
        font-weight: 600;
      }
    }

    .right-container {
      flex: 5;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: white;
      text-align: left;

      .title {
        font-size: 20px;
        line-height: 30px;
        margin-left: 10px;
        font-weight: 600;
      }

      .date {
        font-size: 16px;
        margin-left: 10px;
        font-weight: 600;
        line-height: 20px;
      }
    }

    .useData {
      width: 100%;
      text-align: center;
      position: absolute;
      bottom: 10px;
      right: 10px;
      font-size: 16px;
      font-weight: 600;
      color: #000;
    }
  }

}

.grayscale {
  filter: grayscale(100%);
}
</style>
